import { render, staticRenderFns } from "./Motion.vue?vue&type=template&id=57979872&scoped=true"
import script from "./Motion.vue?vue&type=script&lang=js"
export * from "./Motion.vue?vue&type=script&lang=js"
import style0 from "./Motion.vue?vue&type=style&index=0&id=57979872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57979872",
  null
  
)

export default component.exports